import { resolveAppIconSlug, type AppIconInput } from "./appIcon";

export type AppBrandColorInput = AppIconInput;

/** Bundle IDs with no icon slug that still have a brand color key. */
const IDENTIFIER_COLOR_KEYS: Record<string, string> = {
  "com.microsoft.skype.teams": "teams",
  "com.booking.bookingapp": "booking",
  "net.skyscanner.iphone": "skyscanner",
  "com.withopal.opal": "opal",
  "wtf.riedel.one-sec": "onesec",
  "to.freedom.freedomblocker": "freedom",
  "com.amazon.aiv.aivapp": "primevideo",
};

/** Display names → color key when icon slug is absent. */
const DISPLAY_NAME_COLOR_KEYS: Record<string, string> = {
  teams: "teams",
  chatgpt: "openai",
  "google maps": "googlemaps",
  mail: "mailbox",
  "booking.com": "booking",
  skyscanner: "skyscanner",
  preferences: "settings",
  settings: "settings",
  opal: "opal",
  "one-sec": "onesec",
  "one sec": "onesec",
  freedomblocker: "freedom",
  freedom: "freedom",
  aivapp: "primevideo",
  "prime video": "primevideo",
};

/** Icon slugs that differ from catalog color keys. */
const ICON_SLUG_COLOR_KEYS: Record<string, string> = {
  applemail: "mailbox",
  bookingdotcom: "booking",
};

export function resolveAppColorKey({ displayName, appIdentifier, category }: AppBrandColorInput): string | null {
  const iconSlug = resolveAppIconSlug({ displayName, appIdentifier, category });
  if (iconSlug) {
    return ICON_SLUG_COLOR_KEYS[iconSlug] ?? iconSlug;
  }

  const idKey = (appIdentifier ?? "").trim().toLowerCase();
  if (idKey && idKey in IDENTIFIER_COLOR_KEYS) {
    return IDENTIFIER_COLOR_KEYS[idKey]!;
  }

  const displayKey = (displayName ?? "").trim().toLowerCase();
  if (displayKey && displayKey in DISPLAY_NAME_COLOR_KEYS) {
    return DISPLAY_NAME_COLOR_KEYS[displayKey]!;
  }

  return null;
}

export function resolveBrandColorHex(
  app: AppBrandColorInput,
  brandMap: Readonly<Record<string, string>> | undefined,
): string | undefined {
  if (!brandMap) return undefined;
  const key = resolveAppColorKey(app);
  if (!key) return undefined;
  const hex = brandMap[key];
  if (!hex || !/^#[0-9a-fA-F]{6}$/.test(hex)) return undefined;
  return hex.toLowerCase();
}
